import { Bot, FileUp, KeyRound, Plus } from 'lucide-react'

interface HomeQuickActionsProps {
  onCreateDocument: () => void
  onUploadFile: () => void
  onCreateAgentKey: () => void
  onConnectMcp: () => void
  createPending?: boolean
  showUpload?: boolean
  showCreateDocument?: boolean
  showCreateAgentKey?: boolean
}

export function HomeQuickActions({
  onCreateDocument,
  onUploadFile,
  onCreateAgentKey,
  onConnectMcp,
  createPending = false,
  showUpload = true,
  showCreateDocument = true,
  showCreateAgentKey = true,
}: HomeQuickActionsProps) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      {showCreateDocument && (
        <button
          type="button"
          className="aw-quick-action"
          onClick={onCreateDocument}
          disabled={createPending}
        >
          <span className="aw-quick-action-icon">
            <Plus className="h-5 w-5" />
          </span>
          <span>
            <span className="aw-quick-action-title">Create document</span>
            <br />
            <span className="aw-quick-action-sub">Start the first canonical note</span>
          </span>
        </button>
      )}
      {showUpload && (
        <button type="button" className="aw-quick-action" onClick={onUploadFile}>
          <span className="aw-quick-action-icon">
            <FileUp className="h-5 w-5" />
          </span>
          <span>
            <span className="aw-quick-action-title">Upload file</span>
            <br />
            <span className="aw-quick-action-sub">Extract a source for search</span>
          </span>
        </button>
      )}
      {showCreateAgentKey && (
        <button type="button" className="aw-quick-action" onClick={onCreateAgentKey}>
          <span className="aw-quick-action-icon">
            <KeyRound className="h-5 w-5" />
          </span>
          <span>
            <span className="aw-quick-action-title">Create agent key</span>
            <br />
            <span className="aw-quick-action-sub">Grant scoped API access</span>
          </span>
        </button>
      )}
      <button type="button" className="aw-quick-action agent" onClick={onConnectMcp}>
        <span className="aw-quick-action-icon">
          <Bot className="h-5 w-5" />
        </span>
        <span>
          <span className="aw-quick-action-title">Connect MCP</span>
          <br />
          <span className="aw-quick-action-sub">Open agent setup guide</span>
        </span>
      </button>
    </div>
  )
}
